import axios from '../utils/axios';

export default function createMailer(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/tag-mailers', data)
    )
}
